import { ApplePayIcon, GooglePayIcon, WalletIcon } from '@razz-team/ui-web';
import { ApiDigitalWalletTokenRequestor } from '../../openapi';

export function DigitalWalletTokenRequestorIcon({
  tokenRequestor,
}: {
  tokenRequestor: ApiDigitalWalletTokenRequestor;
}) {
  switch (tokenRequestor) {
    case 'APPLE_PAY':
      return <ApplePayIcon />;
    case 'GOOGLE_PAY':
      return <GooglePayIcon />;
    default:
      return <WalletIcon />;
  }
}
